varying vec3 vParticleColor;

void main()
{
    float distanceToCenter = distance(gl_PointCoord, vec2(0.5));

    // More intense glow with smoother falloff
    float strength = 0.04 / distanceToCenter - 0.08;
    strength = max(0.0, strength);

    // Add soft edge glow
    float softGlow = 1.0 - smoothstep(0.0, 0.1, distanceToCenter);
    strength += softGlow * 0.1;

    gl_FragColor = vec4(vParticleColor, strength);
}